import type React from 'react';
import MiddleEllipsis from 'react-middle-ellipsis';
import classNames from '../../../../utils/classNames';

interface SwarmNameProps {
    name: string;
    iconClass: string | null;
    /** Dims the icon, e.g. for a measuring point without an attached device. */
    dimIcon?: boolean;
}

/** Swarm type icon followed by a name that is shortened in the middle when it does not fit. */
export function SwarmName({
    name,
    iconClass,
    dimIcon = false,
}: SwarmNameProps): React.ReactElement {
    return (
        <div className="flex min-w-0 items-center gap-2">
            {iconClass && (
                <span
                    className={classNames(
                        iconClass,
                        dimIcon && 'detached-device',
                        'inline-block h-5 w-5 shrink-0 bg-contain bg-center bg-no-repeat'
                    )}
                    aria-hidden
                />
            )}
            <div className="min-w-0 flex-1 whitespace-nowrap text-gray-900" title={name}>
                <MiddleEllipsis>
                    <span>{name}</span>
                </MiddleEllipsis>
            </div>
        </div>
    );
}
